const GOOGLE_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

export function getGoogleClientId() {
	return process.env.REACT_APP_GOOGLE_CLIENT_ID || null;
}

export function preloadGoogleIdentityScript() {
	return new Promise((resolve, reject) => {
		if (window.google?.accounts?.id) {
			resolve(window.google);
			return;
		}
		const existing = document.querySelector(`script[src="${GOOGLE_SCRIPT_URL}"]`);
		if (existing) {
			existing.addEventListener('load', () => resolve(window.google));
			existing.addEventListener('error', reject);
			return;
		}
		const script = document.createElement('script');
		script.src = GOOGLE_SCRIPT_URL;
		script.async = true;
		script.defer = true;
		script.onload = () => resolve(window.google);
		script.onerror = reject;
		document.head.appendChild(script);
	});
}

export async function initializeGoogleIdentity(callback) {
	const clientId = getGoogleClientId();
	if (!clientId) return null;
	const google = await preloadGoogleIdentityScript().catch(() => null);
	if (!google?.accounts?.id) return null;
	google.accounts.id.initialize({ client_id: clientId, callback });
	return google;
}
